import { Box, Button, Typography, Container, Link } from "@mui/material";
import { ArrowBack, Image } from "@mui/icons-material";
import notFound from "../../Assets/404.svg";
export default function NotFound() {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#000", // Background to match dark theme
      }}
    >
      <Container
        maxWidth="lg"
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
          p: 3,
        }}
      >
        <Box
          sx={{
            width: "100%",
            maxWidth: "900px",
            backgroundColor: "#111", // Dark card background
            borderRadius: "12px",
            border: "1px solid rgba(255, 255, 255, 0.1)",
            p: 5,
            boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.2)",
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            alignItems: "center",
            justifyContent: "space-between",
            gap: 4,
          }}
        >
          {/* Left Section - Text */}
          <Box sx={{ flex: 1, textAlign: "center", color: "#fff" }}>
            <Typography
              variant="h3"
              sx={{ fontWeight: "bold", color: "#E0E0E0", mb: 2 }}
            >
              404 - Page Not Found
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontSize: "18px",
                color: "#B0B0B0",
                maxWidth: "500px",
                mx: "auto",
              }}
            >
              The page you're looking for doesn't exist or has been moved. Head
              back to our homepage to explore more.
            </Typography>

            {/* Buttons */}
            <Box
              sx={{
                mt: 4,
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                gap: 2,
                justifyContent: "center",
              }}
            >
              <Link href="/" passHref>
                <Button
                  variant="contained"
                  sx={{
                    backgroundColor: "#3498db",
                    "&:hover": { backgroundColor: "#2980b9" },
                    px: 4,
                    py: 1.5,
                  }}
                >
                  <ArrowBack sx={{ mr: 1 }} />
                  Back to Home
                </Button>
              </Link>

              <Link href={`dashboard/createChatbot`} passHref>
                <Button
                  variant="outlined"
                  sx={{
                    border: "1px solid rgba(255,255,255,0.2)",
                    color: "#B0B0B0",
                    "&:hover": { backgroundColor: "rgba(255,255,255,0.1)" },
                    px: 4,
                    py: 1.5,
                  }}
                >
                  View Dashboard
                </Button>
              </Link>
            </Box>
          </Box>

          {/* Right Section - Illustration */}
          <Box
            sx={{
              width: "280px",
              height: "280px",
              position: "relative",
            }}
          >
            <Image
              src={notFound}
              alt="404 Illustration"
              layout="fill"
              objectFit="contain"
              priority
            />
          </Box>
        </Box>
      </Container>
    </Box>
  );
}
